import { z } from 'zod';
/**
 * SZAVAZAS (versenyaudit U4).
 *
 * Egy- vagy tobbvalasztos, lehet nevtelen, lehet hatarideje, es a keszito
 * (vagy admin) kezzel is lezarhatja. Az eredmeny elo: minden szavazat utan
 * a csatorna `poll.updated` esemenyt kap.
 */
/**
 * Ennyi valaszlehetoseg adhato egy szavazasban (csatornaban es olelesben is).
 * Korabban tiz volt; egy nagyobb csapatnal (idopont, hely, nev) ez keves.
 */
export const MAX_POLL_OPTIONS = 20;
export const MAX_POLL_QUESTION = 300;
export const MAX_POLL_OPTION_TEXT = 200;
export const createPollInput = z.object({
    question: z.string().trim().min(1).max(MAX_POLL_QUESTION),
    options: z
        .array(z.string().trim().min(1).max(MAX_POLL_OPTION_TEXT))
        .min(2, 'Legalább két válaszlehetőség kell.')
        .max(MAX_POLL_OPTIONS)
        .refine((options) => new Set(options.map((o) => o.toLowerCase())).size === options.length, 'Két válaszlehetőség nem lehet ugyanaz.'),
    multiple: z.boolean().default(false),
    anonymous: z.boolean().default(false),
    /** Hatarido, ISO. `null`: amig le nem zarjak. */
    closesAt: z.string().nullable().default(null),
});
export const votePollInput = z.object({
    /** A valasztott opciok. Ures lista: a szavazat visszavonasa. */
    optionIds: z.array(z.string()).max(MAX_POLL_OPTIONS),
});
export const pollOptionSchema = z.object({
    id: z.string(),
    text: z.string(),
    votes: z.number(),
    /** Kik szavaztak ra - nevtelen szavazasnal mindig ures. */
    voterIds: z.array(z.string()),
});
export const pollSchema = z.object({
    id: z.string(),
    messageId: z.string(),
    channelId: z.string(),
    createdBy: z.string(),
    question: z.string(),
    multiple: z.boolean(),
    anonymous: z.boolean(),
    closesAt: z.string().nullable(),
    closedAt: z.string().nullable(),
    /** Lezart: kezzel, vagy lejart a hatarido. */
    isClosed: z.boolean(),
    /** Hany KULONBOZO ember szavazott. */
    voterCount: z.number(),
    options: z.array(pollOptionSchema),
    /** A nezo sajat szavazatai (opcio-azonositok). */
    myVotes: z.array(z.string()),
});
//# sourceMappingURL=poll.js.map